import { FC, ReactNode } from 'react';
import { Button, SxProps, Theme, Typography } from '@mui/material';
import { PhoenixGridHeaderFlex, SectionHeader } from '@styles/Admin-tools/LenderUtilityStyles';
import { SaveButton } from '@shared/inputs/Buttons';
import { SectionTitle } from '@shared/components/SectionTitle';

interface ILenderUtilitySectionHeaderProps {
  title: string;
  titleFontWeight?: number;
  subtitle?: string;
  buttonTitle?: string;
  buttonWidth?: string;
  justify?: string;
  disabled?: boolean;
  children?: ReactNode;
  marginBottom?: string;
  titleColor?: string;
  btn?: FC<{ children?: ReactNode }>;
  showClearFilter?: boolean;
  disableFilterBtn?: boolean;
  onButtonClick?(): void;
  handleClearAll?(): void;
  clearAllFilterBtnSx?: SxProps<Theme>;
}

export const PhoenixGridHeader = ({
  title,
  titleFontWeight,
  subtitle,
  buttonTitle,
  justify,
  disabled,
  buttonWidth,
  onButtonClick,
  handleClearAll,
  showClearFilter,
  disableFilterBtn,
  clearAllFilterBtnSx,
  children,
  titleColor,
  btn: Btn
}: ILenderUtilitySectionHeaderProps) => (
  <SectionHeader justify={justify}>
    <PhoenixGridHeaderFlex>
      {title && <SectionTitle fontWeight={titleFontWeight} title={title} color={titleColor} />}
      {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
      {showClearFilter && 
         <Button
          size='small'
          variant='contained'
          disabled={disableFilterBtn}
          sx={{ width: '120px', marginTop: '2px', ...clearAllFilterBtnSx }}
          onClick={handleClearAll} 
          >
          Clear All Filters
        </Button>
      }
    </PhoenixGridHeaderFlex>

    <PhoenixGridHeaderFlex>
      {children}

      {buttonTitle ? (
        Btn ? (
          <div style={{ width: buttonWidth || '136px', pointerEvents: disabled ? 'none' : 'auto' }} onClick={onButtonClick}>
            <Btn>{buttonTitle}</Btn>
          </div>
        ) : (
          <SaveButton label={buttonTitle} sx={{ width: buttonWidth }} disabled={disabled} onClick={onButtonClick} />
        )
      ) : null}
    </PhoenixGridHeaderFlex>
  </SectionHeader>
);
